import { render, staticRenderFns } from "./settingsUsers.vue?vue&type=template&id=1e60244c&scoped=true&"
import script from "./settingsUsers.vue?vue&type=script&lang=js&"
export * from "./settingsUsers.vue?vue&type=script&lang=js&"
import style0 from "./settingsUsers.vue?vue&type=style&index=0&id=1e60244c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60244c",
  null
  
)

export default component.exports